// [2026-08-12] ADDED — InC-Proctor sign-in handoff.
//
// One flow only: trade this operator's live admin session for a single-use code that opens the
// proctoring dashboard already authenticated.

import {
  PROCTOR_HANDOFF,
  PROCTOR_HANDOFF_SUCCESS,
  PROCTOR_HANDOFF_FAILURE,
} from "./types";

export const proctorHandoff = (payload) => ({
  type: PROCTOR_HANDOFF,
  payload,
});

export const proctorHandoffSuccess = () => ({
  type: PROCTOR_HANDOFF_SUCCESS,
});

export const proctorHandoffFailure = (payload) => ({
  type: PROCTOR_HANDOFF_FAILURE,
  payload,
});
